module.exports = __webpack_public_path__ + "static/img/a3.47dcd2a0.png";